import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ApplicationStatusEnum, ApplicationUser } from '@tran-monorepo/interfaces/applications';
import { mapApplicationUserToAuthUser } from '../../../utils';
import { UserAvatarComponent } from '../../user-avatar';

@Component({
    selector: 'tran-application-requesters',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, UserAvatarComponent],
    templateUrl: './application-requesters.component.html'
})
export class ApplicationRequestersComponent {
    public readonly requesters = input.required<ApplicationUser[]>();
    public readonly label = input<string>('');

    protected readonly requesterUsers = computed(() =>
        this.requesters().map(requester => mapApplicationUserToAuthUser(requester))
    );

    protected readonly ApplicationStatus = ApplicationStatusEnum;
}
